export const API_ENDPOINTS = {
  EXAMPLE: "example/",
  FACTSPLIT: "text/fact-split",
  SUMMARIZE: "text/summarize",
  JSONFIX: "json/fix"
};
